import { render, staticRenderFns } from "./ChangeOwnership.vue?vue&type=template&id=5251f59b&scoped=true"
import script from "./ChangeOwnership.vue?vue&type=script&lang=js"
export * from "./ChangeOwnership.vue?vue&type=script&lang=js"
import style0 from "./ChangeOwnership.vue?vue&type=style&index=0&id=5251f59b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251f59b",
  null
  
)

export default component.exports